import React from 'react';
import {
  LineageBrowserDataCatalogProvider,
  VizPortalDataCatalogProviderProps,
} from '../../../data-catalog-shared';
import { FlowLineageSubplaceRouter, FlowLineageSubplaceRouterProps } from './FlowLineageSubplace';

export type EmbeddableFlowSubplaceProps = VizPortalDataCatalogProviderProps & FlowLineageSubplaceRouterProps;

export function EmbeddableFlowSubplaceWithoutRouter(props: EmbeddableFlowSubplaceProps): JSX.Element {
  return (
    <LineageBrowserDataCatalogProvider {...props}>
      <FlowLineageSubplaceRouter flowVizportalUrlId={props.flowVizportalUrlId} shouldShowFlowParametersWarning={props.shouldShowFlowParametersWarning} />
    </LineageBrowserDataCatalogProvider>
  );
}
